import { PlatformConfig } from './types';

export const PLATFORM_CONFIGS: Record<string, PlatformConfig> = {
  iam: {
    name: 'IAM',
    icon: '/images/platforms/iam.svg'
  },
  billing: {
    name: 'Billing',
    icon: '/images/platforms/billing.svg'
  },
  // eslint-disable-next-line camelcase
  v2_1: {
    name: 'Dashboard',
    icon: '/images/platforms/dashboard.svg'
  },
  // eslint-disable-next-line camelcase
  lp_generator: {
    name: 'LP Generator',
    icon: '/images/platforms/lp-generator.svg'
  },
  // eslint-disable-next-line camelcase
  wordline_s2s: {
    name: 'S2S',
    icon: '/images/platforms/wordline.svg'
  },
  adz: {
    name: 'AdForce',
    icon: '/images/platforms/adz.svg'
  }
};
